import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';
import { initialSliderGroupState } from '../../models/sliderGroupModel';

export const fetchSliderGroup = createAsyncThunk(
    'sliderGroup/fetchSliderGroup',
    async (_, thunkAPI) => {
        try {
            const response = await apiService('/SliderGroup/GetAll');
            if (response.isSuccess) {
                return response.result;
            } else {
                return thunkAPI.rejectWithValue(response.message || 'Hata oluştu');
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const sliderGroupSlice = createSlice({
    name: 'sliderGroup',
    initialState: initialSliderGroupState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderGroup.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSliderGroup.fulfilled, (state, action) => {
                state.loading = false;
                state.dataSliderGroup = action.payload;
            })
            .addCase(fetchSliderGroup.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default sliderGroupSlice.reducer;
